import { keyDifferences, chooseIf, kitBox } from '../../data/compare';
import { COMPARE_CTX } from '../../lib/compareTray';

// "Key differences": what really separates the ACs on the table, one plain
// line each, then "Choose X if ..." for each AC that wins at something, and
// the pipe-kit box when an AC on the table is sold both ways. Every line is
// worked out from the spec sheets and prices in data/compare.js.

export default function KeyDifferences({ units, answers }) {
  if (units.length < 2) return null;
  const diffs = keyDifferences(units, answers, COMPARE_CTX);
  const chooses = chooseIf(units);
  const kit = kitBox(units, COMPARE_CTX);
  if (!diffs.length && !chooses.length && !kit) return null;

  return (
    <section className="mt-5 rounded-xl border border-blue-100 bg-blue-50 p-4" data-testid="key-differences">
      <h2 className="text-base font-bold text-gray-900 md:text-lg">Key differences</h2>
      {diffs.length > 0 && (
        <ul className="mt-3 space-y-2.5">
          {diffs.map((d) => (
            <li key={d.key} className="flex flex-col gap-0.5 text-sm leading-relaxed sm:flex-row sm:gap-3" data-testid={`diff-${d.key}`}>
              <span className="shrink-0 font-semibold text-blue-900 sm:w-32">{d.lead}</span>
              <span className="min-w-0 text-gray-800">{d.text}</span>
            </li>
          ))}
        </ul>
      )}

      {chooses.length > 0 && (
        <div className="mt-4 grid gap-3 sm:grid-cols-2" data-testid="choose-if">
          {chooses.map((c) => (
            <div key={c.id} className="rounded-lg border border-blue-100 bg-white p-3">
              <p className="text-sm font-bold text-gray-900">{c.title}</p>
              <ul className="mt-1.5 list-disc space-y-1 pl-4 text-[13px] leading-relaxed text-gray-800">
                {c.points.map((p) => <li key={p}>{p}</li>)}
              </ul>
            </div>
          ))}
        </div>
      )}

      {kit && (
        <div className="mt-4 rounded-lg border border-gray-200 bg-white p-3" data-testid="kit-box">
          <p className="text-sm font-bold text-gray-900">{kit.title}</p>
          <ul className="mt-1.5 list-disc space-y-1 pl-4 text-[13px] leading-relaxed text-gray-800">
            {kit.lines.map((l) => <li key={l}>{l}</li>)}
            {kit.tips.map((t) => <li key={t.lead}><span className="font-semibold">{t.lead}</span> {t.text}</li>)}
          </ul>
        </div>
      )}
    </section>
  );
}
